import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
    selector: "app-redirects-to-signup",
    templateUrl: "./redirects-to-signup.component.html",
    styleUrls: ["./redirects-to-signup.component.scss"],
    standalone: true,
})
export class RedirectsToSignupComponent implements OnInit {
  constructor(private router: Router, private dialog: MatDialogRef<RedirectsToSignupComponent>) {}

  ngOnInit() {
    setTimeout(() => {
      this.dialog.close();
      this.router.navigate(["/signup"]);
    }, 2000);
  }
}
